var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgEYeillustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 70,
    viewBox: "0 0 119 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3137_3949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.327 17.2016C109.177 7.78129 82.7843 8.11705 53.3783 17.9515C23.9723 27.7859 2.68805 43.3949 5.83853 52.8152C8.989 62.2354 35.3812 61.8997 64.7872 52.0653C94.1932 42.2308 115.478 26.6218 112.327 17.2016Z",
    stroke: "#08841B",
    strokeWidth: 0.539768,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6666 23.443C90.5161 14.0227 72.4793 11.5642 53.3802 17.9516C34.281 24.339 21.3521 37.1537 24.5026 46.574C27.6531 55.9942 45.6899 58.4528 64.789 52.0654C83.8882 45.6779 96.8171 32.8633 93.6666 23.443Z",
    stroke: "#08841B",
    strokeWidth: 0.539768,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.328 17.2013L5.83984 52.8149",
    stroke: "#08841B",
    strokeWidth: 0.539768,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.877 29.0577C73.7265 19.6374 63.2065 14.6649 53.3799 17.9513C43.5533 21.2377 38.1412 31.5385 41.2917 40.9587C44.4421 50.379 54.9621 55.3515 64.7888 52.0651C74.6154 48.7787 80.0275 38.478 76.877 29.0577Z",
    fill: "#08841B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5859 31.4962C67.7265 25.9364 61.5174 23.0017 55.7174 24.9414C49.9175 26.8811 46.7231 32.9607 48.5825 38.5205C50.4419 44.0803 56.651 47.015 62.4509 45.0753C68.2508 43.1355 71.4453 37.056 69.5859 31.4962Z",
    fill: "#11120D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7687 39.1672C59.1448 37.3016 57.0668 36.3151 55.1273 36.9637C53.1878 37.6124 52.1214 39.6505 52.7453 41.5161C53.3692 43.3817 55.4472 44.3682 57.3867 43.7196C59.3262 43.071 60.3926 41.0328 59.7687 39.1672Z",
    fill: "#08841B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3137_3949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.1826,
    height: 112.533,
    fill: "white",
    transform: "translate(11.4766 70.0059) rotate(-108.492)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEYeillustration);
export default __webpack_public_path__ + "static/media/eYE ILLUSTRATION.e4972f1b9ff3ecc8eeb7da621cae5284.svg";
export { ForwardRef as ReactComponent };